import React from 'react';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  pageSize: number;
  totalItems: number;
  hasNextPage?: boolean;
  hasPrevPage?: boolean;
  isApproximate?: boolean;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  pageSize,
  totalItems,
  hasNextPage,
  hasPrevPage,
  isApproximate = false,
  onPageChange,
  onPageSizeChange,
}) => {
  const resolvedHasPrevPage = hasPrevPage ?? currentPage > 1;
  const resolvedHasNextPage = hasNextPage ?? (currentPage < totalPages && totalPages > 0);
  const totalPagesLabel = isApproximate
    ? `${Math.max(currentPage, totalPages || currentPage)}${resolvedHasNextPage ? '+' : ''}`
    : `${totalPages || 1}`;

  return (
    <div className="pagination">
      <button
        className="btn btn-pagination"
        disabled={!resolvedHasPrevPage}
        onClick={() => onPageChange(currentPage - 1)}
      >
        ← Önceki
      </button>

      <div className="page-info">
        <span>
          Sayfa {currentPage} / {totalPagesLabel}
        </span>
        <select
          className="page-size-select"
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
        >
          <option value="10">Sayfa başına 10</option>
          <option value="25">Sayfa başına 25</option>
          <option value="50">Sayfa başına 50</option>
          <option value="100">Sayfa başına 100</option>
        </select>
      </div>

      <button
        className="btn btn-pagination"
        disabled={!resolvedHasNextPage}
        onClick={() => onPageChange(currentPage + 1)}
      >
        Sonraki →
      </button>
    </div>
  );
};

export default Pagination;
